import ic_add_white from "../../assets/add-icon-white@2x.png";
import ic_add from "../../assets/add-icon@2x.png";
import ic_back from "../../assets/arrow-back@2x.png";
import bg_layer from "../../assets/bg-layer@2x.png";
import ic_calendar from "../../assets/calendar@2x.png";
import ic_check from "../../assets/check@2x.png";
import ic_clients_act from "../../assets/clients-active@2x.png";
import ic_clients from "../../assets/clients@2x.png";
import ic_cancel from "../../assets/close@2x.png";
import ic_dashboard_act from "../../assets/dashboard-active@2x.png";
// NavMenu Icons
import ic_dashboard from "../../assets/dashboard@2x.png";
import ic_logo_small from "../../assets/default_logo_black_small.png";
import ic_logo from "../../assets/default_logo_black.png";
import ic_del from "../../assets/Delete@2x.png";
import ic_exercise_act from "../../assets/exercise-active@2x.png";
import ic_exercise from "../../assets/exercise@2x.png";
import ic_filter from "../../assets/filter@2x.png";
import ic_complete from "../../assets/green-check@2x.png";
import ic_access_time from "../../assets/ic_access_time.png";
import ic_alarm_white from "../../assets/ic_alarm_white.png";
import ic_more_menu from "../../assets/ic_more_vert.png";
import ic_alarm from "../../assets/ico_alarm_black.png";
// Settings Icons
import ic_availability from "../../assets/ico_availability@2x.png";
import ic_rem from "../../assets/ico_delete@2x.png";
import ic_edit_white from "../../assets/ico_edit_white.png";
import ic_edit from "../../assets/ico_edit@2x.png";
import ic_general from "../../assets/ico_general@2x.png";
import ic_info from "../../assets/ico_info@2x.png";
import ic_logout from "../../assets/ico_logout@2x.png";
import ic_menu_white from "../../assets/ico_menu_white.png";
import ic_menu from "../../assets/ico_menu.png";
// Other Assets / Common Icons
import ic_settings from "../../assets/ico_settings@2x.png";
import ic_share from "../../assets/ico_share.png";
import ic_stats from "../../assets/ico_statistics@2x.png";
import ic_time from "../../assets/ico_time@2x.png";
import ic_infinity from "../../assets/inifity_blue@2x.png";
import ic_invite_white from "../../assets/invite_icon_white.png";
import ic_invite from "../../assets/invite_icon.png";
// Background Image
import bg_login from "../../assets/login-bg.png";
import ic_placeholder from "../../assets/placeholder@2x.png";
import ic_plus from "../../assets/plus.png";
import ic_schedule_act from "../../assets/schedule-active@2x.png";
import ic_schedule from "../../assets/schedule@2x.png";
import ic_search from "../../assets/search.png";
import ic_profile from "../../assets/user.png";
import ic_user from "../../assets/user.png";
import ic_workout_act from "../../assets/workout-active@2x.png";
import ic_workout from "../../assets/workout@2x.png";

// Exercise Icons

// Workout Icons

// Schedule Icons

const icons = {
  // Exports Ordered Image Arrays
  NavIcons: [ic_dashboard, ic_clients, ic_schedule, ic_workout, ic_exercise],
  NavIconsAct: [ic_dashboard_act, ic_clients_act, ic_schedule_act, ic_workout_act, ic_exercise_act],
  SettingsIcons: [ic_profile, ic_availability, ic_stats, ic_general, ic_logout],
  // Exports Other Assets
  ic_settings,
  ic_exercise,
  ic_workout,
  ic_add,
  ic_add_white,
  ic_back,
  ic_check,
  ic_edit,
  ic_edit_white,
  ic_del,
  ic_rem,
  ic_user,
  ic_logo,
  ic_logo_small,
  ic_search,
  ic_invite,
  ic_invite_white,
  ic_filter,
  ic_placeholder,
  ic_info,
  ic_time,
  ic_menu,
  ic_menu_white,
  ic_share,
  ic_calendar,
  ic_alarm,
  ic_alarm_white,
  ic_access_time,
  ic_more_menu,
  ic_plus,
  ic_infinity,
  ic_cancel,
  ic_complete,
  bg_layer,
  bg_login,
};
export default icons;
